module.exports = __webpack_public_path__ + "img/打印.1d99a2c3.svg";